/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientSearchResultModel } from '../../models/patient-search-result-model';

export interface PatientClinicGroupIdPatientsIndexPageSizeGet$Params {
  clinicGroupId: string;
  index: number;
  pageSize: number;
  searchText?: string;
  sortBy?: string;
  sortDirection?: string;
  dobYear?: number | null;
  dobMonth?: number | null;
  dobDay?: number | null;
}

export function patientClinicGroupIdPatientsIndexPageSizeGet(http: HttpClient, rootUrl: string, params: PatientClinicGroupIdPatientsIndexPageSizeGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, patientClinicGroupIdPatientsIndexPageSizeGet.PATH, 'get');
  if (params) {
    rb.path('clinicGroupId', params.clinicGroupId, {});
    rb.path('index', params.index, {});
    rb.path('pageSize', params.pageSize, {});
    rb.query('searchText', params.searchText, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('dobYear', params.dobYear, {});
    rb.query('dobMonth', params.dobMonth, {});
    rb.query('dobDay', params.dobDay, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<PatientSearchResultModel>;
    })
  );
}

patientClinicGroupIdPatientsIndexPageSizeGet.PATH = '/Patient/{clinicGroupId}/Patients/{index}/{pageSize}';
